export default function Hero() {
  return (
    <section className="hero section-wrap" id="home">
      <div className="hero__copy">
        <p className="eyebrow"><span className="eyebrow__dot" /> Independent software contractor</p>
        <h1>
          Software that moves your work <span>forward.</span>
        </h1>
        <p className="hero__intro">
          I build full-stack web applications for teams that need a practical,
          reliable engineering partner—from the first feature to a product
          that is ready to ship.
        </p>
        <div className="hero__actions">
          <a className="button button--primary" href="#contact">
            Tell me about your project <span aria-hidden="true">↗</span>
          </a>
          <a className="button button--quiet" href="#work">
            Explore selected work <span aria-hidden="true">↓</span>
          </a>
        </div>
        <div className="hero__stack" role="group" aria-label="Core technologies">
          <span>React</span>
          <span>C# / .NET</span>
          <span>Node.js</span>
          <span>PostgreSQL</span>
        </div>
      </div>
      <div className="hero__visual">
        <div className="hero__visual-label">
          <span>FULL-STACK DEVELOPMENT</span>
          <span>01 / 04</span>
        </div>
        <div className="hero__portrait-frame">
          <img src="/portrait.jpg" alt="Colin Harrison" />
        </div>
        <div className="hero__caption">
          <span>Thoughtful engineering.</span>
          <span>Useful software.</span>
        </div>
      </div>
    </section>
  );
}
